export default __webpack_public_path__ + "static/Nurse-c5583526b6e749fae191ca9105e59957.webp";